import React from 'react';
import parse from 'html-react-parser';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {}
        };

        this.load = this.load.bind(this);
    }

    load(e) {
        this.setState(
            {
                data: e
            },
            this.props.onReady
        );
    }

    render() {
        if (!this.state.data || !this.state.data.html)
            return (
                <React.Fragment>
                    <div></div>
                </React.Fragment>
            );

        return (
            <React.Fragment>
                <div>{parse(this.state.data.html)}</div>
            </React.Fragment>
        );
    }
}
